import { Injectable } from '@angular/core';
import { LocalStorageKeys } from '../../../LocalStorageKeys';
import { getXClientId } from '../../../utils/deviceUtils';
import { LocalStorageService } from '../../local-storage/local-storage.service';
import { RegionAPIResult } from '../../location/models/region-result';
import { StorefrontPolicyModel } from './model/StorefrontPolicyModels';

@Injectable({
  providedIn: 'root',
})
export class StorefrontPolicyService {
  private defaultEN = 'en-US';
  private defaultES = 'es-MX';
  private _reg: string;
  private _channels: string;
  constructor(private localStorage: LocalStorageService) {}

  getPolicy(includePrd = false): StorefrontPolicyModel {
    const policy = new StorefrontPolicyModel();
    const profile = this.getSelectedProfile();
    policy.reg = this._reg ? this._reg : this.localStorage.getItem(LocalStorageKeys.COUNTRY_CODE)?.toLowerCase() ?? 'us';
    policy.client = getXClientId();
    policy.pf = profile ? profile.pt : 'main';
    policy.dt = 'web'; //getDeviceType(); TODO: set device type
    policy.ipr = true;
    policy.acl = 'en';
    if (includePrd) {
      policy.prd = 'unowdtc';
    }
    const unChannels = this._channels ?? this.localStorage.getItem(LocalStorageKeys.CHANNEL);
    if (unChannels) policy.un_channels = unChannels;
    return policy;
  }

  getProfile() {
    const profile = this.getSelectedProfile();
    return profile ? profile.pt : 'main';
  }

  getLocale(): string {
    const lang = this.localStorage.getItem(LocalStorageKeys.LANG);
    try {
      const locale = window?.navigator?.language;
      if (locale && lang === 'es' && locale.startsWith(lang)) {
        return locale;
      } else {
        return this.getFallbacks(lang);
      }
    } catch {
      return this.getFallbacks(lang);
    }
  }

  getFallbacks(lang: string) {
    if (lang === 'es') {
      return this.defaultES;
    } else {
      return this.defaultEN;
    }
  }

  setRegion(region: string) {
    this._reg = region;
  }

  setChannels(location: RegionAPIResult) {
    this._channels = (location?.channel ?? []).toString();
  }

  private getSelectedProfile() {
    const profile = this.localStorage.getItem(LocalStorageKeys.SELECTED_PROFILE);
    return profile && profile !== 'undefined' ? JSON.parse(profile) : undefined;
  }
}
